import React, { useState } from "react";
import { Page } from "../../layouts/Page";
import { ProductPageHeader, ProductList } from "../../molecules/ProductList";
import { ProductImportSidebar } from "../../molecules/ProductImportSidebar";
import { ProductSidebar } from "../../molecules/ProductSidebar";
import { TABLE_COLUMNS } from "./constants";
import useInputState from "../../hooks/useInputState";
import {
  useProductList,
  useProductListPagination,
  useProductExport
} from "./hooks";

function Products() {
  const [selectedProductId, setSelectedProductId] = useState();
  const [isProductSidebarOpen, setIsProductSidebarOpen] = useState(false);
  const [isImportSidebarOpen, setIsImportSidebarOpen] = useState(false);

  const [searchText, setSearchText] = useInputState("");
  const { products, loading, fetchMore } = useProductList({ searchText });
  const exportProducts = useProductExport({ searchText });

  const { onScroll, fetchingMore } = useProductListPagination({
    products,
    productsLoading: loading,
    fetchMore,
    searchText
  });

  function addProduct() {
    setSelectedProductId(undefined);
    setIsProductSidebarOpen(true);
  }

  function editProduct(product) {
    setSelectedProductId(product.id);
    setIsProductSidebarOpen(true);
  }

  return (
    <Page title="Your Products" onScroll={onScroll}>
      <ProductImportSidebar
        onImportSidebarClose={() => setIsImportSidebarOpen(false)}
        isImportSidebarOpen={isImportSidebarOpen}
      />

      <ProductSidebar
        productId={selectedProductId}
        sidebarIsOpen={isProductSidebarOpen}
        onDismiss={() => setIsProductSidebarOpen(false)}
        searchText={searchText}
      />

      <ProductPageHeader
        searchText={searchText}
        onSearchTextChange={setSearchText}
        onAddProductPress={addProduct}
        onExportPress={exportProducts}
        onImportPress={() => setIsImportSidebarOpen(true)}
      />

      <ProductList
        products={products}
        isLoading={loading}
        columns={TABLE_COLUMNS}
        isProductListScrollLoading={fetchingMore}
        searchText={searchText}
        onAddProductClick={addProduct}
        onProductRowClick={editProduct}
        onUploadCSVClick={() => setIsImportSidebarOpen(true)}
      />
    </Page>
  );
}

export default Products;
